module.exports = __webpack_public_path__ + "img/lights-holiday.d7f6599f.svg";